import { getAppConfig } from '@bts-web/core-app-config';
import { AppUserFullInfo } from '../../userinfo/types';

export const isDac8FeatureEnabled = (): boolean => {
  const { disableDac8 = false } = getAppConfig();

  return !disableDac8;
};

export const userDidNotProvideTaxDetails = (
  userData: Pick<AppUserFullInfo, 'taxCompliant'>,
): boolean => {
  const { taxCompliant } = userData;

  // Only `false` means the user has not provided the required tax details.
  // `null` applies to users who registered before DAC8 was implemented.
  return isDac8FeatureEnabled() && taxCompliant === false;
};
